<template>
  <path pid="0" d="M18.71 2.63zM19.41 2.84l.09.08-.08-.07-.01-.01zM16.71 4.29l-.11-.09h-.25L16.2 4H15.48l-.08.07-5 5a1 1 0 000 1.42l.1.08a1 1 0 001.32-.08L15 7.41V17a3 3 0 01-3 3H5a1 1 0 000 2h7.22A5 5 0 0017 17V7.41l3.29 3.3a1 1 0 001.42-1.42z"/>
</template>
